import React from 'react';
import Select from 'react-select';
import AppFilterInput from '../../appFilterDashlet/appFilterInput';
import { postEntity } from 'src/utils/entityApi';

import data_modules from 'src/data/dashlet/dashlet-modules';
import withAuth from 'src/hoc/withAuth';

const apiDashboard = '/api/dashboard/';
const maxColumnsForSemiRow = 4;
const maxColumnsForCompleteRow = 8;

const oriState = {
  stepView: 1,
  title: undefined,
  moduleSelected: undefined,
  rowNumber: {
    value: 5,
  },
  columnsOfModule: undefined,
  columnsForFilters: undefined,
  columnsForDisplayOptions: undefined,
  columnsForOrderByOptions: undefined,
  columnsToDisplay: [],
  orderBy: undefined,
  orderDirection: 'DESC',
  rowFilters: {},
  metadata: undefined,
  combinatorialLogic: 'ET',
  userDashboards: undefined,
  dashboardSelected: undefined,
  layout: 'semi-row',
  isFromExisting: false,
};

const stepMax = 2;

{
  /*

This component appears in the modal to create a new dahslet. This component permits the creation of a filtered list dashlet.

*/
}
class DashletListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateListFilters = this.updateListFilters.bind(this);
    this.addRowFilter = this.addRowFilter.bind(this);
    this.removeRowFilter = this.removeRowFilter.bind(this);
    this.decrementStep = this.decrementStep.bind(this);
    this.incrementStep = this.incrementStep.bind(this);
    this.reset = this.reset.bind(this);
    this.refreshFields = this.refreshFields.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputSelectChange(val, typeSelect) {
    this.setState({
      [typeSelect]: val,
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  checkFormIsValid() {
    let noFilterProblem = true;
    for (let [key, filter] of Object.entries(this.state.rowFilters)) {
      if (filter) {
        if (
          !filter.columnSelected ||
          filter.columnSelected === null ||
          !filter.operatorSelected ||
          (filter.operatorSelected && filter.operatorSelected.nbParam > 0 && !filter.param1) ||
          (filter.operatorSelected && filter.operatorSelected.nbParam > 1 && !filter.param2)
        ) {
          noFilterProblem = false;
        }
      }
    }

    return (
      this.state.moduleSelected &&
      this.state.title &&
      this.state.title.trim() !== '' &&
      this.state.columnsToDisplay &&
      this.state.columnsToDisplay.length > 0 &&
      this.state.dashboardSelected &&
      this.state.orderBy &&
      noFilterProblem &&
      ((this.state.columnsToDisplay &&
        this.state.layout === 'semi-row' &&
        this.state.columnsToDisplay.length <= maxColumnsForSemiRow) ||
        (this.state.columnsToDisplay &&
          this.state.layout === 'complete-row' &&
          this.state.columnsToDisplay.length <= maxColumnsForCompleteRow))
    );
  }

  reset() {
    this.state = oriState; // After closing the modal, the rowFilters are still present
    for (let i = 0; i <= Object.keys(this.state.rowFilters).length; i++) {
      this.removeRowFilter();
    }
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormIsValid()) {
        let json = {
          dashlet: {
            title: this.state.title,
            type: 'dashlet-list',
            dashboardId: this.state.dashboardSelected.id,
            metadata: {
              module: this.state.moduleSelected,
              nbRows: this.state.rowNumber['value'],
              orderBy: {
                column: this.state.orderBy,
                orderDirection: this.state.orderDirection,
              },
              displayColumns: this.state.columnsToDisplay,
              combinatorialLogic: this.state.combinatorialLogic,
              filters: this.cleanRowFilter(this.state.rowFilters),
              layout: this.state.layout,
            },
          },
        };
        if (this.state.isFromExisting) {
          let existingDashlet = this.props.fillFromExisting();
          json.dashlet.id = existingDashlet.id;
          this.props.onPostResult('update-dashlet', postEntity(this.props.authFetch, 'dashlet', json));
        } else {
          this.props.onPostResult('dashlet', postEntity(this.props.authFetch, 'dashlet', json));
        }
      } else {
        this.props.openToast(
          false,
          'Certains champs obligatoires sont vides ou le nombres de colonnes est supérieur à la limite : 4 pour un dashlet sur une demi-ligne/ 8 pour un dashlet sur une ligne complète '
        );
      }
    }
  }

  cleanRowFilter = (rowFilter) => {
    const newRowFilter = {};
    let deleteCount = 0;

    Object.keys(rowFilter || {}).forEach((key, index) => {
      if (rowFilter[key] && rowFilter[key].columnSelected) {
        newRowFilter[`filter-${index - deleteCount}`] = rowFilter[key];
      } else {
        deleteCount++;
      }
    });

    return newRowFilter;
  };

  refreshFields(module) {
    this.prepareColumsForFilters(module);
    this.prepareColumnsForDisplayOptions(module);
    this.prepareColumnsForOrderByOptions(module);
  }

  /*
        Some columns can't be filtered
    */
  prepareColumsForFilters(module) {
    if (module) {
      let myColumnsFilters = [];
      for (let i = 0; i < module.columns.length; i++) {
        if (!module.columns[i].noFilter) {
          myColumnsFilters.push(module.columns[i]);
        }
      }
      this.setState({
        columnsForFilters: myColumnsFilters,
      });
    }
  }

  /*
        Some columns can't be displayed in a dashlet, example : employeesConcerned for tasks or appointments
    */
  prepareColumnsForDisplayOptions(module) {
    if (module) {
      let myColumns = [];
      for (let i = 0; i < module.columns.length; i++) {
        if (!module.columns[i].noDisplay) {
          myColumns.push(module.columns[i]);
        }
      }
      this.setState({
        columnsForDisplayOptions: myColumns,
      });
    }
  }

  /*
        Some columns can't be ordered example orderBy the customer of a deal
     */
  prepareColumnsForOrderByOptions(module) {
    if (module) {
      let myColumns = [];
      for (let i = 0; i < module.columns.length; i++) {
        if (!module.columns[i].noOrderBy) {
          myColumns.push(module.columns[i]);
        }
      }
      this.setState({
        columnsForOrderByOptions: myColumns,
      });
    }
  }

  addRowFilter(filter) {
    let newInput = this.state.rowFilters;
    newInput[`filter-${Object.keys(newInput).length}`] = filter;
    this.setState({
      rowFilters: newInput,
    });
  }

  removeRowFilter() {
    let newInputs = this.state.rowFilters;
    delete newInputs[`filter-${Object.keys(newInputs).length - 1}`];
    this.setState({
      rowFilters: newInputs,
    });
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidMount() {
    this.props.onRef(this);

    this.getDashboards();
    /*
            If the modal is open from an existing dashlet in order to update it
         */
    if (this.props.fillFromExisting) {
      let existingDashlet = this.props.fillFromExisting();
      if (existingDashlet && existingDashlet.type === 'dashlet-list') {
        this.setState({
          title: existingDashlet.title,
          rowFilters:
            existingDashlet.metadata.filters.length > 0 || Object.keys(existingDashlet.metadata.filters).length > 0
              ? existingDashlet.metadata.filters
              : {},
          moduleSelected: existingDashlet.metadata.module,
          orderBy: existingDashlet.metadata.orderBy.column,
          orderDirection: existingDashlet.metadata.orderBy.orderDirection,
          columnsToDisplay: (existingDashlet.metadata.displayColumns || []).filter(
            (column) => column.model !== 'expired'
          ),
          layout: existingDashlet.metadata.layout,
          rowNumber: { value: existingDashlet.metadata.nbRows },
          isFromExisting: true,
        });

        this.refreshFields(existingDashlet.metadata.module);
      }
    }
  }

  resetUpdateModule() {
    this.setState({
      columnsToDisplay: undefined,
      orderBy: undefined,
    });

    for (let i = 0; i < Object.keys(this.state.rowFilters).length; i++) {
      this.removeRowFilter();
    }
  }

  getDashboards() {
    let queryURL = apiDashboard;
    let graphQL = '{ dashboards{ id, title } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            userDashboards: data['data']['dashboards'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch dashboards: \n' + error);
        }.bind(this)
      );
  }

  componentDidUpdate(prevProps, prevState) {
    // after input update
    if (prevState.moduleSelected !== this.state.moduleSelected) {
      this.refreshFields(this.state.moduleSelected);
      if (
        prevState.moduleSelected !== undefined &&
        (this.state.columnsToDisplay || this.state.orderBy || Object.keys(this.state.rowFilters).length > 0)
      ) {
        this.resetUpdateModule();
      }
    }
    //Here we want to find the dashboard of the existing dashlet
    if (this.state.isFromExisting && prevState.userDashboards !== this.state.userDashboards) {
      let existingDashlet = this.props.fillFromExisting();
      for (let i = 0; i < this.state.userDashboards.length; i++) {
        if (existingDashlet.dashboard.id === this.state.userDashboards[i].id) {
          this.setState({
            dashboardSelected: this.state.userDashboards[i],
          });
        }
      }
    }

    return true;
  }

  incrementStep() {
    let newStep = this.state.stepView;
    newStep += 1;
    this.setState({
      stepView: newStep,
    });
  }

  decrementStep() {
    let newStep = this.state.stepView;
    newStep -= 1;
    this.setState({
      stepView: newStep,
    });
  }

  removeFilter = (key) => {
    let newInputs = this.state.rowFilters;
    newInputs[key] = undefined;
    this.setState({
      rowFilters: newInputs,
    });
  };

  updateListFilters(key, columnSelected, operatorSelected, param1, param2) {
    // Called when a new row is set

    // 1) Create the object
    let object = {
      columnSelected: columnSelected,
      operatorSelected: operatorSelected,
      param1: param1,
      param2: param2,
    };

    // 2) Update the list
    let list = this.state.rowFilters;
    list[key] = object;
    this.setState({
      rowFilters: list,
    });
  }

  render() {
    if (this.props.isListFormSelected === false) return null;

    const dataRowNumbers = [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }];

    return (
      <div>
        {this.state.stepView === 1 && (
          <div className=''>
            <strong>Paramétrage</strong>
            <div className='form-group'>
              <label>Titre</label>
              <input
                name='title'
                value={this.state.title}
                onChange={this.handleInputChange}
                type='text'
                className='form-control'
                placeholder='Mon Dashlet'
              />
            </div>
            <div className='form-group'>
              <label>Dashboard</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='dashboardSelected'
                value={this.state.dashboardSelected}
                labelKey={'title'}
                valueKey={'title'}
                options={this.state.userDashboards}
                onChange={(val) => this.handleInputSelectChange(val, 'dashboardSelected')}
                noResultsText={'Aucun résultat'}
                placeholder={'Nom'}
                clearValueText={'Supprimer'}
                disabled={!!this.state.isFromExisting}
              />
            </div>
            <div className='form-group'>
              <label>Module</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='moduleSelected'
                value={this.state.moduleSelected}
                labelKey={'name'}
                valueKey={'name'}
                options={data_modules}
                onChange={(val) => this.handleInputSelectChange(val, 'moduleSelected')}
                noResultsText={'Aucun résultat'}
                placeholder={'Nom'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div className='form-group'>
              <label>Nombre de lignes</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='moduleSelected'
                value={this.state.rowNumber}
                labelKey={'value'}
                valueKey={'value'}
                options={dataRowNumbers}
                onChange={(val) => this.handleInputSelectChange(val, 'rowNumber')}
                noResultsText={'Aucun résultat'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div className='form-group'>
              <label>Colonnes à afficher </label>
              <Select
                multi={true}
                className='inputModalSelect'
                name='columnsToDisplay'
                value={this.state.columnsToDisplay}
                labelKey={'label'}
                valueKey={'label'}
                options={this.state.columnsForDisplayOptions}
                onChange={(val) => this.handleInputSelectChange(val, 'columnsToDisplay')}
                noResultsText={'Aucun résultat'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div className='form-group'>
              <label>Trier par</label>
              <Select
                multi={false}
                className='inputModalSelect'
                name='orderBy'
                value={this.state.orderBy}
                labelKey={'label'}
                valueKey={'label'}
                options={this.state.columnsForOrderByOptions}
                onChange={(val) => this.handleInputSelectChange(val, 'orderBy')}
                noResultsText={'Aucun résultat'}
                clearValueText={'Supprimer'}
              />
            </div>
            {/* Order by => DESC or ASC */}
            <div className='custom-control custom-radio'>
              <input
                type='radio'
                className='form-check-input'
                name='orderDirection'
                value='ASC'
                onChange={this.handleInputChange}
                checked={this.state.orderDirection === 'ASC'}
              />
              <label className='custom-control-label'>Croissant</label>
            </div>
            <div className='custom-control custom-radio'>
              <input
                type='radio'
                className='form-check-input'
                name='orderDirection'
                value='DESC'
                onChange={this.handleInputChange}
                checked={this.state.orderDirection === 'DESC'}
              />
              <label className='custom-control-label'>Décroissant</label>
            </div>

            <div className='form-group'>
              <label>Disposition</label>
              <div className='custom-control custom-radio'>
                <input
                  type='radio'
                  className='form-check-input'
                  name='layout'
                  value='complete-row'
                  onChange={this.handleInputChange}
                  checked={this.state.layout === 'complete-row'}
                />
                <label className='custom-control-label'>Ligne entière</label>
              </div>
              <div className='custom-control custom-radio'>
                <input
                  type='radio'
                  className='form-check-input'
                  name='layout'
                  value='semi-row'
                  onChange={this.handleInputChange}
                  checked={this.state.layout === 'semi-row'}
                />
                <label className='custom-control-label'>Demi ligne</label>
              </div>
            </div>
          </div>
        )}

        {this.state.stepView === 2 && (
          <div className='dashlet-filters'>
            <strong>Filtres</strong>
            {/*                        <div className="form-group">
                            <label>Logique combinatoire</label>
                            <Select
                                multi={false}
                                className="inputModalSelect"
                                name="combinatorialLogic" value={this.state.combinatorialLogic}
                                labelKey={"label"}
                                valueKey={"label"}
                                options={combinatorialLogics}
                                onChange={(val)=> this.handleInputSelectChange(val, "orderBy")}
                                noResultsText={"Aucun résultat"} clearValueText={"Supprimer"}
                            />
                        </div>*/}
            <button onClick={() => this.addRowFilter()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus' />
            </button>
            <button onClick={() => this.removeRowFilter()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-minus' />
            </button>

            <div>
              {Object.entries(this.state.rowFilters).map(([inputKey, value]) => (
                <AppFilterInput
                  save={value}
                  id={inputKey}
                  key={inputKey}
                  removeFilter={this.removeFilter}
                  columnsOfModule={this.state.columnsForFilters}
                  updateListFilters={this.updateListFilters}
                />
              ))}
            </div>
          </div>
        )}

        {this.state.stepView < stepMax && (
          <button onClick={this.incrementStep} type='button' className={'btn btn-primary button-dashlet-form'}>
            <span className='icon icon-chevron-right'>Suivant</span>
          </button>
        )}
        {this.state.stepView > 1 && (
          <button onClick={this.decrementStep} type='button' className={'btn btn-primary button-dashlet-form'}>
            <span className='icon icon-chevron-left'>Précédent</span>
          </button>
        )}
      </div>
    );
  }
}

export default withAuth(DashletListForm);
